import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LookerStudioService } from '../../shared/services/integrations/LookerStudioService';
import Loader from '../../shared/components/common/loader/Loader';
import './LookerStudioCallback.scss';
import { INTEGRATIONS } from '../../shared/routes/path';

const LookerStudioCallback: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = searchParams.get('code');
        const error = searchParams.get('error');

        if (error) {
          setStatus('error');
          setMessage(t('authorizationFailed'));
          return;
        }

        if (!code) {
          setStatus('error');
          setMessage(t('noAuthorizationCode'));
          return;
        }

        const success = await LookerStudioService.connect(code);
        
        if (success) {
          setStatus('success');
          setMessage(t('successfullyConnectedToLookerStudio'));
          
          // Zamknij popup i przekieruj
          setTimeout(() => {
            if (window.opener) {
              window.opener.postMessage({ type: 'LOOKER_STUDIO_CONNECTED' }, window.location.origin);
              window.close();
            } else {
              navigate(INTEGRATIONS);
            }
          }, 2000);
        } else {
          setStatus('error');
          setMessage(t('failedToConnectToLookerStudio'));
        }
      } catch (error) {
        console.error('Error handling OAuth callback:', error);
        setStatus('error');
        setMessage(t('authorizationError'));
      }
    };

    handleCallback();
  }, [searchParams, navigate, t]);

  return (
    <div className="looker-studio-callback">
      <div className="callback-container">
        {status === 'loading' && (
          <>
            <Loader />
            <p>{t('connectingToLookerStudio')}</p>
          </>
        )}
        
        {status === 'success' && (
          <>
            <div className="success-icon">✓</div>
            <h2>{t('success')}</h2>
            <p>{message}</p>
          </>
        )}
        
        {status === 'error' && (
          <>
            <div className="error-icon">✗</div>
            <h2>{t('error')}</h2>
            <p>{message}</p>
            <button onClick={() => window.close()}>{t('close')}</button>
          </>
        )}
      </div>
    </div>
  );
};

export default LookerStudioCallback;
